import { render, staticRenderFns } from "./ChangeShiftApplication.vue?vue&type=template&id=0bc71c7c"
import script from "./ChangeShiftApplication.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeShiftApplication.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports